import React, { useMemo, useEffect, useCallback, useState } from "react";
import Chart from "react-apexcharts";
import { CiUser } from "react-icons/ci";
import { PiCubeThin } from "react-icons/pi";
import { Select, Col, Row, Typography, Spin } from "antd";
import axios from "axios";
import moment from "jalali-moment";

import Body from "./Body";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import Card from "../Card";
import { baseURL } from "../../constants/pathnames";

const { Text } = Typography;




const HomePage = () => {
  const { token } = useSelector((state) => state.users);
  const [data, setData] = useState(null);
  const [rangeType, setRangeType] = useState("past_week");

  const header = useMemo(() => {
    const headers = {
      headers: {
        Authorization: `jwt ${token}`,
      },
    };
    return headers;
  }, [token]);

  const getdata = useCallback(() => {
    axios
      .get(`${baseURL}panel/dashboard/reports/histograms/`, header)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [header]);

  useEffect(() => {
    getdata();
  }, [getdata]);

  const chartState1 = {
    legend: {
      show: false,
    },
    options: {
      chart: {
        width: 380,
        type: "donut",
        fontFamily: "iranyekanRegular",
      },
      labels: ["انتخاب نشده", "مرد", "زن"],
      dataLabels: {
        enabled: false,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
          },
        },
      ],
      legend: {
        show: false,
      },
    },
  };

  const chartState2 = {
    options: {
      chart: {
        height: 350,
        type: "bar",
        fontFamily: "iranyekanRegular",
        toolbar: {
          show: false,
        },
      },
      colors: ["#E91E63", "#448AFF", "#4CAF50", "#FFC107"],
      plotOptions: {
        bar: {
          columnWidth: "45%",
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      xaxis: {
        categories: ["رد شده", "ایجاد شده", "تائید شده", "مسدود شده"],
        labels: {
          style: {
            colors: ["#E91E63", "#448AFF", "#4CAF50", "#FFC107"],
            fontSize: "12px",
          },
        },
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          return `<div style="padding:3px 5px;text-align:center;border:0;color:#fff;background-color:${w.globals.colors[dataPointIndex]}">${w.globals.labels[dataPointIndex]} : ${series[0][dataPointIndex]}</div>`;
        },
      },
    },
  };

  const chartState3 = {
    options: {
      chart: {
        height: 350,
        type: "bar",
        fontFamily: "iranyekanRegular",
        toolbar: {
          show: false,
        },
      },

      plotOptions: {
        bar: {
          columnWidth: "45%",
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      xaxis: {
        categories: [
          "فعال",
          "غیرفعال",
          "معاوضه شده",
          "گزارش شده",
          "در حال بررسی",
          "رد شده",
          "تائید شده",
        ],
        labels: {
          style: {
            fontSize: "12px",
          },
        },
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          return `<div style="padding:3px 5px;text-align:center;border:0;color:#fff;background-color:${w.globals.colors[dataPointIndex]}">${w.globals.labels[dataPointIndex]} : ${series[0][dataPointIndex]}</div>`;
        },
      },
    },
  };

  const chartState4 = {
    legend: {
      show: false,
    },
    options: {
      chart: {
        width: 380,
        type: "donut",
        fontFamily: "iranyekanRegular",
      },
      labels: ["نو", "تقریبا نو", "مستعمل(دست دوم)"],
      dataLabels: {
        enabled: false,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
          },
        },
      ],
      legend: {
        show: false,
      },
    },
  };

  const handleChange = (value) => {
    setRangeType(value);
  };

  if (!token) {
    return <Redirect to="/login" />;
  } else {
    return (
      <Body state={0}>
        {!data ? (
          <Spin tip="Loading" size="small"></Spin>
        ) : (
          <>
            <Row className="mb-5">
              <Col className="flex flex-col" span={8}>
                <Text>انتخاب بازه</Text>
                <Select
                  defaultValue="past_week"
                  onChange={handleChange}
                  options={[
                    {
                      value: "past_week",
                      label: `هفته گذشته - (${moment(
                        data?.past_week?.daterange?.gte,'YYYY/MM/DD'
                      ).locale('fa').format("YYYY/MM/DD")} الی ${moment(
                        data?.past_week?.daterange?.lte,'YYYY/MM/DD'
                      ).locale('fa').format("YYYY/MM/DD")} )`,
                    },
                    { value: "past_2_weeks", label: `2 هفته گذشته - (${moment(
                      data?.past_2_weeks?.daterange?.gte,'YYYY/MM/DD'
                    ).locale('fa').format("YYYY/MM/DD")} الی ${moment(
                      data?.past_2_weeks?.daterange?.lte,'YYYY/MM/DD'
                    ).locale('fa').format("YYYY/MM/DD")} )` },
                    { value: "past_month", label: `ماه گذشته - (${moment(
                      data?.past_month?.daterange?.gte,'YYYY/MM/DD'
                    ).locale('fa').format("YYYY/MM/DD")} الی ${moment(
                      data?.past_month?.daterange?.lte,'YYYY/MM/DD'
                    ).locale('fa').format("YYYY/MM/DD")} )` },
                    { value: "past_3_months", label: `3 ماه گذشته - (${moment(
                      data?.past_3_months?.daterange?.gte,'YYYY/MM/DD'
                    ).locale('fa').format("YYYY/MM/DD")} الی ${moment(
                      data?.past_3_months?.daterange?.lte,'YYYY/MM/DD'
                    ).locale('fa').format("YYYY/MM/DD")} )` },
                    { value: "past_6_months", label: `6 ماه گذشته - (${moment(
                      data?.past_6_months?.daterange?.gte,'YYYY/MM/DD'
                    ).locale('fa').format("YYYY/MM/DD")} الی ${moment(
                      data?.past_6_months?.daterange?.lte,'YYYY/MM/DD'
                    ).locale('fa').format("YYYY/MM/DD")} )` },
                  ]}
                />
              </Col>
            </Row>

            <Row gutter={10} className="mb-5">
              <Col lg={8} xs={24}>
                <h4 className="text-gray-700 text-lg">آمار و ارقام</h4>
                <Card className="h-72 flex items-center">
                  <Row className="w-full" gutter={10}>
                    <Col span={12} className="flex gap-2">
                      <div className="w-12 h-12 bg-red-300 bg-opacity-40 rounded-full flex justify-center items-center">
                        <CiUser size={25} className="text-red-800" />
                      </div>
                      <div className="h-12 flex flex-col gap-0 justify-between">
                        <h4 className="text-gray-500">تعداد کاربران</h4>
                        <p>{data[rangeType]?.users?.["total:count"]} نفر</p>
                      </div>
                    </Col>
                    <Col span={12} className="flex gap-2">
                      <div className="w-12 h-12 bg-green-300 bg-opacity-40 rounded-full flex justify-center items-center">
                        <PiCubeThin size={25} className="text-green-800" />
                      </div>
                      <div className="h-12 flex flex-col gap-0 justify-between">
                        <h4 className="text-gray-500">تعداد آگهی ها</h4>
                        <p>{data[rangeType]?.products?.["total:count"]}</p>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col lg={16} xs={24}>
                <h4 className="text-gray-700 text-lg">وضعیت آگهی ها</h4>
                <Card className="h-72">
                  <Chart
                    options={chartState3.options}
                    series={[
                      {
                        data: [
                          data[rangeType]?.products?.[
                            "product_status:count:active"
                          ],
                          data[rangeType]?.products?.[
                            "product_status:count:deactive"
                          ],
                          data[rangeType]?.products?.[
                            "product_status:count:exchanged"
                          ],
                          data[rangeType]?.products?.[
                            "product_status:count:reported"
                          ],
                          data[rangeType]?.products?.[
                            "product_status:count:checking"
                          ],
                          data[rangeType]?.products?.[
                            "product_status:count:rejected"
                          ],
                          data[rangeType]?.products?.[
                            "product_status:count:approved"
                          ],
                        ],
                      },
                    ]}
                    type="bar"
                    height={250}
                  />
                </Card>
              </Col>
            </Row>
            <Row className="mt-5" gutter={10}>
              <Col lg={6} xs={24}>
                <h4 className="text-gray-700 text-lg">نوع آگهی ها</h4>
                <Card className="h-72">
                  <Chart
                    options={chartState4.options}
                    series={[
                      data[rangeType]?.products?.["product_type:count:new"],
                      data[rangeType]?.products?.[
                        "product_type:count:almost_new"
                      ],
                      data[rangeType]?.products?.["product_type:count:used"],
                    ]}
                    type="pie"
                    height={250}
                  />
                </Card>
              </Col>
              <Col lg={12} xs={24}>
                <h4 className="text-gray-700 text-lg">وضعیت کاربران</h4>
                <Card className="h-72">
                  <Chart
                    options={chartState2.options}
                    series={[
                      {
                        data: [
                          data[rangeType]?.users?.["status:count:rejected"],
                          data[rangeType]?.users?.["status:count:created"],
                          data[rangeType]?.users?.["status:count:approved"],
                          data[rangeType]?.users?.["status:count:suspended"],
                        ],
                      },
                    ]}
                    type="bar"
                    height={250}
                  />
                </Card>
              </Col>
              <Col lg={6} xs={24}>
                <h4 className="text-gray-700 text-lg">جنسیت کاربران</h4>
                <Card className="h-72">
                  <Chart
                    options={chartState1.options}
                    series={[
                      data[rangeType]?.users?.["gender:count:not selected"],
                      data[rangeType]?.users?.["gender:count:male"],
                      data[rangeType]?.users?.["gender:count:female"],
                    ]}
                    type="pie"
                    height={250}
                  />
                </Card>
              </Col>
            </Row>
          </>
        )}
      </Body>
    );
  }
};

export default HomePage;
